/* eslint-disable @typescript-eslint/no-explicit-any */
import { createSlice, PayloadAction } from '@reduxjs/toolkit'
import { useSelector } from 'react-redux';
import { RootState } from '../configureStore';

export interface ThemeState {
    isDarkTheme: boolean;
    isAutoTheme: boolean;
}

export const useThemeState = () => {
    const themeState = useSelector((state: RootState | any) => state.theme as ThemeState);
    return themeState;
}

// Define the initial state using that type
const initialState: ThemeState = {
    isDarkTheme: false,
    isAutoTheme: false
}

export const themeSlice = createSlice({
    name: 'theme',
    // `createSlice` will infer the state type from the `initialState` argument
    initialState,
    reducers: {
        setIsDarkThemeAction: (state, action: PayloadAction<boolean>) => {
            state.isDarkTheme = action.payload;
        },    
        setIsAutoThemeAction: (state, action: PayloadAction<boolean>) => {
            state.isAutoTheme = action.payload;
        }
    }
})

export const { setIsDarkThemeAction, setIsAutoThemeAction } = themeSlice.actions;

export default themeSlice.reducer;